export default __webpack_public_path__ + "static/media/do_properexpose.ce7ee7d3.png";